// utils/Toast.js
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export const ErrorToast = (message, onClickAction) => {
  toast.info(
    ({ closeToast }) => (
      <div className="flex flex-col gap-2">
        <span>{message}</span>
        <button
          className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
          onClick={() => {
            onClickAction();
            closeToast();
          }}
        >
          Go to Upload Page
        </button>
      </div>
    ),
    {
      position: "top-center",
      autoClose: false,
      closeOnClick: false,
      closeButton: true,
    }
  );
};
